import moment from "moment"

export function getSum(total, num) {
  return total + num
}

export function customFormatter(date) {
  return moment(date).format("yyyy-MM-DD")
}
